import React, { Component } from "react";

import Header from "../preapps/Header";
import { UserData, Logout, getDropUsers } from "../../api";
import "./dashboard.scss";
import AppsProcessing from "./apps-processing";
import SetGoal from "./set-goal";
import AppsMetrics from "./apps-metric";
import AnalyticsOverview from "./analytics-overview";
import CustomDashModal from "../modals/custom-dashboard-modal/custom-dashboard-modal";

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            customDashModal: false,
            dashboardWidgets: {
                analyticsOverview: false,
                dailyGoal: false,
                appsMetrics: false,
                appsProcessing: false,
            },
            dropDownUsers: [],
        };
    }

    componentDidMount = async () => {
        await UserData()
            .then((response) => {
                getDropUsers().then((res) => {
                    const orgOption = res.organization.map((t) => {
                        return {
                            value: "org-" + t.id,
                            label: t.name,
                        };
                    });
                    const agentOption = res.agents.map((t) => {
                        return {
                            value: "agent-" + t.id,
                            label: t.name,
                        };
                    });
                    const DropDownOptions = [
                        {
                            label: "Organization",
                            options: orgOption,
                        },
                        {
                            label: "Agents",
                            options: agentOption,
                        },
                    ];
                    this.setState({ dropDownUsers: DropDownOptions });
                });

                let isAdmin =
                    response.organization_id === 1 && response.role === "admin"
                        ? true
                        : false;
                let user = response;
                let widgetState = {
                    analyticsOverview: true,
                    dailyGoal: true,
                    appsMetrics: true,
                    appsProcessing: true,
                };

                if (user.dashboard_state !== null) {
                    widgetState = JSON.parse(response.dashboard_state);
                }

                this.setState({
                    user: response,
                    dashboardWidgets: widgetState,
                });
            })
            .catch((error) => console.log(error));
    };

    handleSearchChange(evt) {
        const serachValue = evt.currentTarget.value;
        this.props.handleSearchEvent(serachValue);
    }

    handleKeyPress(evt) {
        if (evt.key === "Enter") {
            evt.preventDefault();
        }
    }

    logout() {
        Logout()
            .then((response) => {
                window.location = "/";
            })
            .catch((error) => console.log(error));
    }

    updateUser = () => {
        UserData()
            .then((response) => {
                let isAdmin =
                    response.organization_id === 1 && response.role === "admin"
                        ? true
                        : false;
                let user = response;
                this.setState({ user: response });
            })
            .catch((error) => console.log(error));
    };

    openCustomDashModal = () => {
        this.setState({ customDashModal: true });
    };

    closeCustomDashModal = () => {
        this.setState({ customDashModal: false });
    };

    updateWidgets = (data) => {
        this.setState({
            dashboardWidgets: data,
        });
    };

    updateDropUser = (value) => {
        getDropUsers({ user: value }).then((res) => {
            const orgOption = res.organization.map((t) => {
                return {
                    value: "org-" + t.id,
                    label: t.name,
                };
            });
            const agentOption = res.agents.map((t) => {
                return {
                    value: "agent-" + t.id,
                    label: t.name,
                };
            });
            const DropDownOptions = [
                {
                    label: "Organization",
                    options: orgOption,
                },
                {
                    label: "Agents",
                    options: agentOption,
                },
            ];
            this.setState({ dropDownUsers: DropDownOptions });
        });
    };

    render() {
        const { user, betaFeature, dropDownUsers } = this.state;
        return (
            <div className="website-wrapper application-page organizationsPage dashboard-page-wrapper">
                <div className="org-page  page-bottom-wrap">
                    <div className="container-fluid">
                        <div className="panel-heading" id="pannel-headingId">
                            <div className="d-flex">
                                <h4 className="customise-dashboard-heading">
                                    Dashboard{" "}
                                </h4>
                                <button
                                    className="orgbtn customise-dashbtn"
                                    onClick={this.openCustomDashModal}
                                >
                                    Customise dashboard
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid dashboard">
                        <div className="row dashboard-row">
                            <div className="col-md-8">
                                <div className="row">
                                    {this.state.dashboardWidgets
                                        .analyticsOverview && (
                                        <div className="col-md-12 apps-process">
                                            <AnalyticsOverview
                                                dropDownUsers={dropDownUsers}
                                                user={this.state.user}
                                                updateDropUser={
                                                    this.updateDropUser
                                                }
                                            />
                                        </div>
                                    )}

                                    {this.state.dashboardWidgets
                                        .appsMetrics && (
                                        <div className="col-md-12 apps-process">
                                            <AppsMetrics
                                                user={this.state.user}
                                                dropDownUsers={dropDownUsers}
                                                updateDropUser={
                                                    this.updateDropUser
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="row">
                                    {this.state.dashboardWidgets.dailyGoal && (
                                        <div
                                            className={`col-md-12 col-pl apps-process ${this.state.dashboardWidgets.dailyGoal && !this.state.dashboardWidgets.analyticsOverview ? "col4" : ""}`}
                                        >
                                            <SetGoal
                                                user={this.state.user}
                                                getUpdatedUser={this.updateUser}
                                                dropDownUsers={dropDownUsers}
                                                updateDropUser={
                                                    this.updateDropUser
                                                }
                                            />
                                        </div>
                                    )}

                                    {this.state.dashboardWidgets
                                        .appsProcessing && (
                                        <div className="col-md-12 col-pl apps-process">
                                            <AppsProcessing
                                                dropDownUsers={dropDownUsers}
                                                user={this.state.user}
                                                updateDropUser={
                                                    this.updateDropUser
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.customDashModal && (
                    <CustomDashModal
                        show={this.state.customDashModal}
                        closeModal={this.closeCustomDashModal}
                        updateWidgets={this.updateWidgets}
                        dashboardWidgets={this.state.dashboardWidgets}
                    />
                )}
            </div>
        );
    }
}

export default Dashboard;
